import React, { useRef } from "react";
import ErrorBanner, {
  ValidationError,
} from "../../../components/common/ErrorBanner";

interface UploadDocumentSectionProps {
  selectedFile: File | null;
  fileFormatError: string;
  fileSizeError: string;
  isSaveEnabled: boolean;
  uploadLoading: boolean;
  validationErrors: ValidationError[];
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSaveDocument: () => void;
  onCancel: () => void;
}

const UploadDocumentSection: React.FC<UploadDocumentSectionProps> = ({
  selectedFile,
  fileFormatError,
  fileSizeError,
  isSaveEnabled,
  uploadLoading,
  validationErrors,
  onFileChange,
  onSaveDocument,
  onCancel,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleChooseFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const renderFileError = () => {
    if (fileFormatError) {
      return (
        <p className="p3 mt-0! text-[12px]! text-border-red flex items-center gap-2">
          <img
            src="/assets/images/errorCircleSmall.svg"
            alt="Error icon"
            className="w-4! h-4!"
          />
          {fileFormatError}
        </p>
      );
    }
    if (fileSizeError) {
      return (
        <p className="p3 mt-0! text-[12px]! text-border-red flex items-center gap-2">
          <img
            src="/assets/images/errorCircleSmall.svg"
            alt="Error icon"
            className="w-4! h-4!"
          />
          {fileSizeError}
        </p>
      );
    }
    return <p className="p3 -dolphin mt-0!">Max file size 10 MB</p>;
  };

  return (
    <div className="flex-1">
      <p className="p3 -book my-0!">
        File Types Allowed : Office Files(.doc, .docx, .xls,.xlsx,
        .csv,.ppt,.pptx,.pdf,.txt), Image files(.bmp,.gif,.jpg,.png).
      </p>

      <div className="inline-flex items-center mt-6! gap-2 border border-gray-300 bg-[#F7F7F7] text-[#878F9B] p-4!">
        <input
          ref={fileInputRef}
          type="file"
          onChange={onFileChange}
          style={{ display: "none" }}
          accept=".doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,.pdf,.txt,.bmp,.gif,.jpg,.png"
        />
        <button
          type="button"
          className="button -light  whitespace-nowrap flex items-center gap-2 shrink-0"
          onClick={handleChooseFile}
        >
          <img
            src="/assets/images/uploadOutline.svg"
            className="shrink-0"
            aria-hidden="true"
            alt="Upload file icon"
          />
          <span>Choose File</span>
        </button>
        {renderFileError()}
      </div>

      {selectedFile && (
        <div className="mt-2">
          <span>Selected file: {selectedFile.name}</span>
        </div>
      )}

      <div className="flex flex-col-reverse gap-4! desktop:gap-3! desktop:flex-row mt-6!">
        <button
          type="button"
          className="button -light m-0! desktop:w-auto! self-stretch flex items-center justify-center box-border max-w-none"
          onClick={onCancel}
        >
          <span className="flex items-center justify-center w-full">
            Cancel
          </span>
        </button>
        <button
          type="button"
          className="button -primary -light desktop:w-auto!  m-0! self-stretch flex items-center justify-center box-border max-w-none!"
          onClick={onSaveDocument}
          disabled={!isSaveEnabled || uploadLoading}
        >
          <span className="flex items-center justify-center w-full">
            {uploadLoading ? "Uploading..." : "Save Document"}
          </span>
        </button>
      </div>

      {validationErrors.length > 0 && (
        <div className="mt-4">
          <ErrorBanner errors={validationErrors} />
        </div>
      )}
    </div>
  );
};

export default UploadDocumentSection;
